export default {
    LAUNCH_RESEARCH: (state, payload) => {
        state.launch_research = payload.launch;
    },
    SELECT: (state, payload) => {
        state[payload.key] = payload.value;
    },
};